
import React, { Component } from "react";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStroopwafel } from "@fortawesome/free-solid-svg-icons";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { faAngleDown,faStopCircle,faCircle,
} from "@fortawesome/free-solid-svg-icons";
import { Menu, Label, Button, Popup, Icon, Accordion } from "semantic-ui-react";
import moment from "moment";
//import { DateInput } from "semantic-ui-calendar-react";
import colors from "../../colors";
import axios from "axios";
import domain from "../../domain";
import calendar from "../assets/calendar.ico";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


library.add(faStroopwafel);
library.add(faAngleRight);
library.add(faAngleDown);
library.add(faStopCircle);
library.add(faCircle);
var authType = "Basic";
var username = "NhpAdmin";
var password = "nhp@1234";
var basicAuth = authType + btoa(username + ":" + password);
axios.defaults.headers.common["Authorization"] = basicAuth;
let clickcount = 0;
export default class TreeNode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: false,
      margin: props.margin,
      // selected: false,
      color: colors["final_side_sub"],
      prevColor: props.color,
      basins: null,
      defaultsubbasin: false,
      subbasin: null,
      dsubbasin: null,
      graphdata: null,
      analysisstatus: false,
      subdiv: false,
      mycolor: "blue",
      childenable: false,
    };
  }
/////////////////////////////////////////////ORIGINAL EXISITING CODE FOR ONCLICK AND ONCLICKCHILD_MAIN////////////////////////////////////////////////////////
  onClick = () => {
    if (clickcount !== 0) this.props.handleTabClick(this.props.data.id);
    
    this.setState({
      collapsed: !this.state.collapsed,
      color: !this.state.collapsed
        ? colors["sidebar-sub-menu"]
        : this.state.prevColor,
      subdiv: false,
    });
    clickcount++;
  };

  onClickChild_main = () => {
   this.setState({
     childenable: true,
   });

  };

  onClickChild2 = (e) => {
    e.preventDefault();
    this.props.setSelectedLayer(
      this.props.data.name + "_" + e.target.innerText
    );

    this.props.setDefaultInfo(this.props.data.information);
    this.setState({
      mycolor: "green",
      mycolor1: "blue",
      mycolor2: "blue",
    });
  };
  onClickChild3 = (e) => {
    e.preventDefault();
    this.props.setSelectedLayer(
      this.props.data.name + "_" + e.target.innerText
    );
    this.props.setDefaultInfo(this.props.data.information);
    this.setState({
      mycolor: "blue",
      mycolor1: "green",
      mycolor2: "blue",
    });
  };

  onClickChild4 = (e) => {
    e.preventDefault();
    this.props.setSelectedLayer(
      this.props.data.name + "_" + e.target.innerText
    );
    this.props.setDefaultInfo(this.props.data.information);
    this.setState({
      mycolor: "blue",
      mycolor1: "blue",
      mycolor2: "green",
    });
  };

  onClickChild = () => {
   
    if (this.props.data.ismap) {
      this.props.toggleSelectedNodeStatus(
        this.props.parent + "-" + this.props.data.name
      );
      this.props.setSelectedMenu(this.props.data.name);
      this.props.enableDatePicker(this.props.data.dateReq);
      this.props.enableSlider(this.props.data.sliderReq);
      //  this.props.enableForecast(this.props.data.forecast)
      this.props.enableForecast(false);
      this.props.setDefaultInfo(this.props.data.information);
    }
    if (this.props.data.issub) {
      this.props.toggleSelectedNodeStatus(
        this.props.parent + "-" + this.props.data.name
      );
      this.props.setSelectedMenu(this.props.data.name);
      this.props.enableDatePicker(this.props.data.sliderReq);
      this.props.enableSlider(this.props.data.sliderReq);
      this.props.enableForecast(this.props.data.forecast);
      this.props.setDefaultInfo(this.props.data.information);
      let date = moment(this.props.date, "DD MMMM YYYY")
        .add(0, "days")
        .format("DD MMMM YYYY");
      // this.props.setForecastDate(date)
      this.props.setSelectedLayer(
        this.props.data.name +
          "_" +
          moment(date, "DD MMMM YYYY").add(0, "days").format("DD MMMM YYYY")
      );
    }
  };

  componentDidMount() {
    if (this.props.data.hasdefault) {
      this.onClick();
    }
    if (
      this.props.selectedLayerLink === this.props.data.name ||
      this.props.data.default
    ) {
      this.onClickChild();
    }
  }

  handleKeyPress = (e) => {
    e.preventDefault();
   //console.log("dispppp",e.keyCode);
  };
  render() {
   //console.log(this.props.inlinemode);
    const enabledDates = this.props.availableDates.map((momentDate) => momentDate.toDate());

   //console.log("ggggggggggggfdgdfgggggggggggg",this.props.selectedNodeStaus[this.props.parent + "-" + this.props.data.name])
    let river_system, river_basins;
    let subtree = null;

    if (this.props.riversystem) {
      river_system = this.props.riversystem.map((result, k) => {
        return (
          <option key={k} value={result.basin}>
            {result.basin}
          </option>
        );
      });
    }
    if (this.props.river_basins) {
      river_basins = this.props.river_basins.map((result, k) => {
        return (
          <option key={k} value={result.basin}>
            {result.basin}
          </option>
        );
      });
    }
    //console.log(this.props.date)
    if (this.props.data.children) {
      subtree = this.props.data.children.map((child, key) => {
        //console.log(child.name==='BasinWise')
        return (
          <TreeNode
            key={key}
            data={child}
            setSelectedLayer={this.props.setSelectedLayer}
            setSelectedMenu={this.props.setSelectedMenu}
            margin={this.state.margin + 5}
            color={this.state.color}
            selectedLayerLink={this.props.selectedLayerLink}
            toggleSelectedNodeStatus={this.props.toggleSelectedNodeStatus}
            selectedNodeStaus={this.props.selectedNodeStaus}
            parent={this.props.data.name}
            enableDatePicker={this.props.enableDatePicker}
            enableSlider={this.props.enableSlider}
            enableForecast={this.props.enableForecast}
            isForecast={this.props.data.forecast}
            activeIndex={this.props.activeIndex}
            date={this.props.date}
            setDefaultInfo={this.props.setDefaultInfo}
            setDate={this.props.setDate}
            childenable={this.props.childenable}
            availableDates={this.props.availableDates}
            
            handleDateChange={this.props.handleDateChange}
            active={this.props.active}
            handleTabClick={this.props.handleTabClick}
            riversystem={this.props.riversystem}
            river_basins={this.props.river_basins}
            handleStartDateChange={this.props.handleStartDateChange}
            handleEndDateChange={this.props.handleEndDateChange}
            changeRiverBasin={this.props.changeRiverBasin}
            changeRiverName={this.props.changeRiverName}
            handleClick_Stats={this.props.handleClick_Stats}
            startdate={this.props.startdate}
            enddate={this.props.enddate}
            inlinemode={this.props.inlinemode}
            modeChange={this.props.modeChange}
          />
        );
      });
    }
//==============================================here you renamed to snowmelt runoff fore, as the tab snowmelt runoff forecast is getting disabled
    if (subtree) {
      const tooltipTitle = this.props.data.id === 1 ? "Display Snow Cover Map" : this.props.data.id === 2 ? "Choose a Date for 3 –day Forecast and Daily Snowmelt Rate Product.\nClick on the Map to see the pixel-wise melt rate(s)" : "";
      return (
        <div className="modalwindow" style={{ padding: "0px" }}>
          <div
            data-id={this.props.data.id}
            onClick={
              this.props.data.name !== "Snowmelt Runoff Forecast"
                ? this.onClick
                : null
            }
            className="modalheader"
            title={tooltipTitle}
            disabled={this.props.data.disabled}
            style={{ textAlign: "left", margin: "0px" }}
          >
            <div style={{ display: "flex" }}>
              <div
                style={{
                  width: "80%",
                  opacity: !this.props.data.disabled ? "1" : "0.5",
                  fontSize: !this.props.data.disabled ? "13px" : "unset",
                  color: !this.props.data.disabled ? colors.textcolor : "unset",
                  fontWeight: !this.props.data.disabled ? "bold" : "unset",
                }}
              >
                {this.props.data.displayname}
              </div>
              <div style={{ textAlign: "right", width: "20%" }}>
                {this.props.active ? (
                  <FontAwesomeIcon icon="angle-down" />
                ) : (
                  <FontAwesomeIcon icon="angle-right" />
                )}
              </div>
            </div>
          </div>

          {this.props.active ? (
            <div style={{ background: colors["final_side_sub"] }}>
              {subtree}
            </div>
          ) : null}
        </div>
      );
    } else {
      return (
        <div style={{ padding: "0px"}}>
          <div className="grid-container" >
            <div
              class="grid-child"
              style={{
                background: this.state.color,
                width: "180px",
                color: colors.text_sub_color,
              }}
            >
              <Menu.Item
                as="div"
                data-id={this.props.data.id}
                onClick={!this.props.data.disabled ? this.onClickChild : null}
                style={{ textAlign: "left", color: colors.text_sub_color }}
                disabled={this.props.data.disabled}
                title={this.props.data.title}
              >
                <div style={{ display: "flex" }}>
                  {this.props.data.ismap ? (
                    <div style={{ width: "10%" }}>
                      {this.props.selectedNodeStaus[
                        this.props.parent + "-" + this.props.data.name
                      ] ? (
                        <FontAwesomeIcon icon="stop-circle" />
                      ) : (
                        <FontAwesomeIcon icon="circle" />
                      )}
                    </div>
                  ) : this.props.data.issub ? (
                    <div style={{ width: "10%" }}>
                      {this.props.selectedNodeStaus[
                        this.props.parent + "-" + this.props.data.name
                      ] ? (
                        <FontAwesomeIcon icon="stop-circle" />
                      ) : (
                        <FontAwesomeIcon icon="circle" />
                      )}
                    </div>
                  ) : null}

                  <div style={{ width: "90%" }}>
                    {this.props.data.displayname}
                  </div>
                </div>
              </Menu.Item>
            </div>

            <div
              class="grid-child"
              style={{
                background: this.state.color,
                textAlign: "right",
                margin: "auto",
              }}
            >
              <div class="row">
               
                <div class="column">
                  {this.props.selectedNodeStaus[
                    this.props.parent + "-" + this.props.data.name
                  ] ? (
                    <Popup
                      position="top right"
                      basic
                      onOpen={
                       this.props.modeChange
                      }
                      open={this.props.inlinemode}
                      //onClose={this.props.modeChange}
                      trigger={
                        <img
                          src={calendar}
                          width="20"
                          height="20"
                          align="right"
                          alt="calendar"
                        ></img>
                      }
                      on="click"
                    > {this.props.inlinemode?
                
                      <DatePicker
                      closeOnScroll={true}

                        // inline
                        name="date"
                       inline={true}
                       
                        value={moment(this.props.date, "DD-MM-YYYY").format(
                          "DD-MM-YYYY"
                        )}
                        openToDate={moment(this.props.date, "DD-MM-YYYY").toDate()} // Opens on the selected date

                        onChange={(date) => this.props.handleDateChange(null, { name: 'date', value: moment(date).format('DD-MM-YYYY') })}
                        dateFormat="DD-MM-YYYY"
                        highlightDatesStyles="orange"
                        placeholder="Date"
                        iconPosition="left"
                        highlightDates={enabledDates.map(date => moment(date, 'DD-MM-YYYY').toDate())}
                        filterDate={(date) => enabledDates.some((enabledDate) => enabledDate.toDateString() === date.toDateString())}
                        dayClassName={(date) => {
                          const isEnabled = enabledDates.some(
                            (enabledDate) => enabledDate.toDateString() === date.toDateString()
                          );
                          return isEnabled ? 'highlighted-day' : ''; // Add custom class to enabled dates
                        }}
                        showMonthDropdown
                        showYearDropdown
                        scrollableYearDropdown
                        closable
                        //initialDate={this.props.date}
                        ///enable={this.props.availableDates}
                        //marked={this.props.availableDates}
                       //highlightDates={this.props.availableDates.map(date => moment(date, 'DD-MM-YYYY').toDate())}
                        //includeDates={this.props.availableDates.map((date) =>
                       //   moment(date, "DD-MM-YYYY").toDate()
                       // )}
                        startMode="day"
                        pickerWidth="200px"
                       
                        popupPosition="top right"
                        clearIcon={<Icon name="remove" color="red" />}
                        minDate={new Date(Math.min(...enabledDates.map((d) => d.getTime())))} // Set the minimum date
                        maxDate={new Date(Math.max(...enabledDates.map((d) => d.getTime())))} // Set the maximum date
                     
                      /> 
                      
                      :null
                      }
                    </Popup>
                  ) : null}
                </div>
              </div>
            </div>
          </div>

{/*==========================================================Forecast TAB DROPDOWN STARTS HERE============================================================== */}
          {this.props.data.issub &&
          this.props.selectedNodeStaus[
            this.props.parent + "-" + this.props.data.name
          ] ? (
            <div style={{ textAlign: "left" }}>
              <div style={{ textAlign: "right" }}>
                <Button
                  as="div"
                  labelPosition="right"
                  style={{ marginLeft: "50px" }}
                  //onClick={this.onClickChild_main}
                >
                  <Label
                    as="a"
                    basic
                    color={this.state.mycolor}
                    pointing="left"
                  >
                    {"Forecasted on " +
                      moment(this.props.date, "DD-MM-YYYY")
                        .add(0, "days")
                        .format("DD MMMM YYYY")}
                  </Label>
                </Button>
              </div>
             
                <div style={{ textAlign: "left" }}>
                  <Button
                    as="div"
                    labelPosition="right"
                    style={{ marginLeft: "50px" }}
                    onClick={this.onClickChild2}
                  >
                    <Label
                      as="a"
                      basic
                      color={this.state.mycolor}
                      pointing="left"
                    >
                      {moment(this.props.date, "DD-MM-YYYY")
                        .add(0, "days")
                        .format("DD MMMM YYYY")}
                    </Label>
                  </Button>
                  <Button
                    as="div"
                    labelPosition="right"
                    style={{ marginLeft: "50px" }}
                    onClick={this.onClickChild3}
                  >
                    <Label
                      as="a"
                      basic
                      color={this.state.mycolor1}
                      pointing="left"
                    >
                      {moment(this.props.date, "DD-MM-YYYY")
                        .add(1, "days")
                        .format("DD MMMM YYYY")}{" "}
                    </Label>
                  </Button>
                  <Button
                    as="div"
                    labelPosition="right"
                    style={{ marginLeft: "50px" }}
                    onClick={this.onClickChild4}
                  >
                    <Label
                      as="a"
                      basic
                      color={this.state.mycolor2}
                      pointing="left"
                    >
                      {moment(this.props.date, "DD-MM-YYYY")
                        .add(2, "days")
                        .format("DD MMMM YYYY")}{" "}
                    </Label>
                  </Button>
                </div>
           
            </div>
          ) : null}

{/*==========================================================Daily Snow Cover TAB DROPDOWN STARTS HERE============================================================== */}
          {this.props.data.name === "Daily Snow Cover" &&
          this.props.selectedNodeStaus[
            this.props.parent + "-" + this.props.data.name
          ] ? (
            <div className="modalwindow">
              <div className="modalheader" style={{ textAlign: "left" }} title="Get Spatial (Basin wise) and Temporal (Time-series) Statistics">
                Snow Cover Area Statistics
              </div>

              <div
                className="modalbox"
                style={{ textAlign: "left", padding: "0px" }}
              >
                <Accordion styled className="acc_styles">
                  <Accordion.Title
                    active={this.props.activeIndex === 0}
                    index={0}
                    onClick={this.props.handleClick_Stats}
                    className="acc_title_1"
                    //title="Daily-Basin Level Statistics"
                    title="Choose a Basin for Daily Snow Cover Statistics"

                  >
                    
                    <Icon name="dropdown" />
                    Daily- Basin Level 
                  </Accordion.Title>
                  <Accordion.Content active={this.props.activeIndex === 0}>
                    <div className="modalbox">
                      <select
                        value={this.props.riverselected}
                        onChange={this.props.changeRiverName}
                      >
                        <option value="#">Select River System</option>
                        {river_system}
                      </select>
                    </div>
                  </Accordion.Content>

                  <Accordion.Title
                    active={this.props.activeIndex === 1}
                    index={1}
                    onClick={this.props.handleClick_Stats}
                    title="Choose a Date range along with River-system and/or Basin to display corresponding Snow Cover Time-series graph"

                  >
                    <Icon name="dropdown" />
                    Time Series
                  </Accordion.Title>
                  <Accordion.Content
                    active={this.props.activeIndex === 1}
                    style={{ width: "200px", margin: "0px" }}
                  >
                    <div
                      className="modalbox"
                      style={{ textAlign: "left", padding: "1px" }}
                    >
                      <DatePicker
                        // inline
                        //readOnly
                        onKeyDown={this.handleKeyPress}
                        showIcon
                        toggleCalendarOnIconClick

                        icon={
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="1em"
                            height="1em"
                            viewBox="0 0 48 48"
                            style={{ color: '#888' }} // Set color here

                          >
                            <mask id="ipSApplication0">
                              <g fill="none" stroke="#fff" strokeLinejoin="round" strokeWidth="4">
                                <path strokeLinecap="round" d="M40.04 22v20h-32V22"></path>
                                <path
                                  fill="#fff"
                                  d="M5.842 13.777C4.312 17.737 7.263 22 11.51 22c3.314 0 6.019-2.686 6.019-6a6 6 0 0 0 6 6h1.018a6 6 0 0 0 6-6c0 3.314 2.706 6 6.02 6c4.248 0 7.201-4.265 5.67-8.228L39.234 6H8.845l-3.003 7.777Z"
                                ></path>
                              </g>
                            </mask>
                            <path
                              fill="currentColor"
                              d="M0 0h48v48H0z"
                              mask="url(#ipSApplication0)"
                            ></path>
                          </svg>
                        }
                        // required
                        // readOnly
                        name="startdate"
                        value={moment(
                          this.props.startdate,
                          "DD-MM-YYYY"
                        ).format("DD-MM-YYYY")}
                        openToDate={moment(this.props.startdate, "DD-MM-YYYY").toDate()} // Opens on the selected date

                        onChange={(date) => this.props.handleStartDateChange(null, { name: 'startdate', value: moment(date).format('DD-MM-YYYY') })}
                        placeholder="Start Date"
                        iconPosition="right"
                        closable
                       showMonthDropdown
                        showYearDropdown
                        highlightDates={enabledDates.map(date => moment(date, 'DD-MM-YYYY').toDate())}
                        filterDate={(date) => enabledDates.some((enabledDate) => enabledDate.toDateString() === date.toDateString())}
                        dayClassName={(date) => {
                          const isEnabled = enabledDates.some(
                            (enabledDate) => enabledDate.toDateString() === date.toDateString()
                          );
                          return isEnabled ? 'highlighted-day' : ''; // Add custom class to enabled dates
                        }}
                        scrollableYearDropdown
                        // highlightDates={this.props.availableDates.map(date => moment(date, 'DD-MM-YYYY').toDate())}
                        // includeDates={this.props.availableDates.map((date) =>
                        //   moment(date, "DD-MM-YYYY").toDate()
                        // )}

                        //enable={this.props.availableDates}
                        //marked={this.props.availableDates}
                        highlightDatesStyles="teal"
                        width="200px"
                        pickerStyle={{ width: "200px" }}
                        // startMode="date"
                        pickerWidth="200px"
                        popupPosition="top right"
                        clearIcon={<Icon name="remove" color="red" />}
                        minDate={new Date(Math.min(...enabledDates.map((d) => d.getTime())))} // Set the minimum date
                        maxDate={new Date(Math.max(...enabledDates.map((d) => d.getTime())))} // Set the maximum date
                    
                      />
                          
                      <DatePicker
                        onKeyDown={this.handleKeyPress}
                        showIcon
                        toggleCalendarOnIconClick

                        icon={
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="1em"
                            height="1em"
                            viewBox="0 0 48 48"
                          >
                            <mask id="ipSApplication0">
                              <g fill="none" stroke="#fff" strokeLinejoin="round" strokeWidth="4">
                                <path strokeLinecap="round" d="M40.04 22v20h-32V22"></path>
                                <path
                                  fill="#fff"
                                  d="M5.842 13.777C4.312 17.737 7.263 22 11.51 22c3.314 0 6.019-2.686 6.019-6a6 6 0 0 0 6 6h1.018a6 6 0 0 0 6-6c0 3.314 2.706 6 6.02 6c4.248 0 7.201-4.265 5.67-8.228L39.234 6H8.845l-3.003 7.777Z"
                                ></path>
                              </g>
                            </mask>
                            <path
                              fill="currentColor"
                              d="M0 0h48v48H0z"
                              mask="url(#ipSApplication0)"
                            ></path>
                          </svg>
                        }
                        
                        

                        name="enddate"
                        iconPosition="left"
                        openToDate={moment(this.props.enddate, "DD-MM-YYYY").toDate()} // Opens on the selected date

                        showMonthDropdown
                        showYearDropdown
                        value={moment(this.props.enddate, "DD-MM-YYYY").format(
                          "DD-MM-YYYY"
                        )}
                        onChange={(date) => this.props.handleEndDateChange(null, { name: 'enddate', value: moment(date).format('DD-MM-YYYY') })}
                      
                        placeholder="End Date"
                        iconPosition="right"
                        closable
                        // initialDate={this.props.date}
                        //value={this.props.date}
                        //enable={this.props.availableDates}
                        //marked={this.props.availableDates}
                            highlightDates={enabledDates.map(date => moment(date, 'DD-MM-YYYY').toDate())}
                          filterDate={(date) => enabledDates.some((enabledDate) => enabledDate.toDateString() === date.toDateString())}
                          dayClassName={(date) => {
                            const isEnabled = enabledDates.some(
                              (enabledDate) => enabledDate.toDateString() === date.toDateString()
                            );
                            return isEnabled ? 'highlighted-day' : ''; // Add custom class to enabled dates
                          }}
                        scrollableYearDropdown
                        highlightDatesStyles="teal"

                        // startMode="date"
                        pickerWidth="300px"
                        popupPosition="top right"
                        clearIcon={<Icon name="remove" color="red" />}
                        minDate={new Date(Math.min(...enabledDates.map((d) => d.getTime())))} // Set the minimum date
                        maxDate={new Date(Math.max(...enabledDates.map((d) => d.getTime())))} // Set the maximum date
                    
                      />
                      <select
                        value={this.props.riverselected}
                        onChange={this.props.changeRiverName}
                      >
                        <option value="#">Select River System</option>
                        {river_system}
                      </select>

                      <select
                        value={this.props.river_basin_selected}
                        onChange={this.props.changeRiverBasin}
                      >
                        <option value="#">Select Basin</option>
                        {river_basins}
                      </select>
                    </div>
                  </Accordion.Content>
                </Accordion>
              </div>
              
            </div>
            
          ) : null}


{/*==========================================================Snow Cover Fraction TAB DROPDOWN STARTS HERE============================================================== */}
{this.props.data.name === "Snow Cover Fraction" &&
          this.props.selectedNodeStaus[
            this.props.parent + "-" + this.props.data.name
            
          ] ? ( 
            <div className="modalwindow"
            title="Choose a Date range for Fortnightly Snow Cover Fraction(SCF).
Click on the map to display corresponding timeseries SCF graph.">
             
              <div
                className="modalbox"
                style={{ textAlign: "left", padding: "0px" }}
                
              >
                <Accordion styled className="acc_styles">
              

                  <Accordion.Title
                    active={this.props.activeIndex === 0}
                    index={1}
                    onClick={this.props.handleClick_Stats}
                    
                  >
                    <Icon name="dropdown" />
                    Time Series
                  </Accordion.Title>
                  <Accordion.Content
                    active={this.props.activeIndex === 1}
                    style={{ width: "200px", margin: "0px" }}
                    
                  >
                    <div
                      className="modalbox"
                      style={{ textAlign: "left", padding: "1px" }}
                     
                    >
                      <DatePicker
                            toggleCalendarOnIconClick

                        onKeyDown={this.handleKeyPress}
                        showIcon
                        icon={
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="1em"
                            height="1em"
                            viewBox="0 0 48 48"
                          >
                            <mask id="ipSApplication0">
                              <g fill="none" stroke="#fff" strokeLinejoin="round" strokeWidth="4">
                                <path strokeLinecap="round" d="M40.04 22v20h-32V22"></path>
                                <path
                                  fill="#fff"
                                  d="M5.842 13.777C4.312 17.737 7.263 22 11.51 22c3.314 0 6.019-2.686 6.019-6a6 6 0 0 0 6 6h1.018a6 6 0 0 0 6-6c0 3.314 2.706 6 6.02 6c4.248 0 7.201-4.265 5.67-8.228L39.234 6H8.845l-3.003 7.777Z"
                                ></path>
                              </g>
                            </mask>
                            <path
                              fill="currentColor"
                              d="M0 0h48v48H0z"
                              mask="url(#ipSApplication0)"
                            ></path>
                          </svg>
                        }
                        name="startdate"
                        openToDate={moment(this.props.startdate, "DD-MM-YYYY").toDate()} // Opens on the selected date

                        iconPosition="right"
                        showMonthDropdown
                        showYearDropdown
                        value={moment(
                          this.props.startdate,
                          "DD-MM-YYYY"
                        ).format("DD-MM-YYYY")}
                        onChange={(date) => this.props.handleStartDateChange(null, { name: 'startdate', value: moment(date).format('DD-MM-YYYY') })}
                        placeholder="Start Date"
                        iconPosition="right"
                        closable
                        //enable={this.props.availableDates}
                        //marked={this.props.availableDates}
                        //highlightDates={this.props.availableDates.map(date => moment(date, 'DD-MM-YYYY').toDate())}
                        //includeDates={this.props.availableDates.map((date) =>
                        //  moment(date, "DD-MM-YYYY").toDate()
                        //)}
                        highlightDates={enabledDates.map(date => moment(date, 'DD-MM-YYYY').toDate())}
                        filterDate={(date) => enabledDates.some((enabledDate) => enabledDate.toDateString() === date.toDateString())}
                        dayClassName={(date) => {
                          const isEnabled = enabledDates.some(
                            (enabledDate) => enabledDate.toDateString() === date.toDateString()
                          );
                          return isEnabled ? 'highlighted-day' : ''; // Add custom class to enabled dates
                        }}
                      scrollableYearDropdown
                        highlightDatesStyles="teal"
                        //markColor="teal"
                        width="200px"
                        pickerStyle={{ width: "200px" }}
                        // startMode="date"
                        pickerWidth="200px"
                        popupPosition="top right"
                        minDate={new Date(Math.min(...enabledDates.map((d) => d.getTime())))} // Set the minimum date
                        maxDate={new Date(Math.max(...enabledDates.map((d) => d.getTime())))} // Set the maximum date
                    
                        clearIcon={<Icon name="remove" color="red" />}
                      />
                      <DatePicker
                        // inline
                        showIcon
                        toggleCalendarOnIconClick

                        icon={
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="1em"
                            height="1em"
                            viewBox="0 0 48 48"
                          >
                            <mask id="ipSApplication0">
                              <g fill="none" stroke="#fff" strokeLinejoin="round" strokeWidth="4">
                                <path strokeLinecap="round" d="M40.04 22v20h-32V22"></path>
                                <path
                                  fill="#fff"
                                  d="M5.842 13.777C4.312 17.737 7.263 22 11.51 22c3.314 0 6.019-2.686 6.019-6a6 6 0 0 0 6 6h1.018a6 6 0 0 0 6-6c0 3.314 2.706 6 6.02 6c4.248 0 7.201-4.265 5.67-8.228L39.234 6H8.845l-3.003 7.777Z"
                                ></path>
                              </g>
                            </mask>
                            <path
                              fill="currentColor"
                              d="M0 0h48v48H0z"
                              mask="url(#ipSApplication0)"
                            ></path>
                          </svg>
                        }
                                        onKeyDown={this.handleKeyPress}
                        name="enddate"
                        value={moment(this.props.enddate, "DD-MM-YYYY").format(
                          "DD-MM-YYYY"
                        )}
                        openToDate={moment(this.props.enddate, "DD-MM-YYYY").toDate()} // Opens on the selected date

                        onChange={(date) => this.props.handleEndDateChange(null, { name: 'enddate', value: moment(date).format('DD-MM-YYYY') })}
                        placeholder="End Date"
                        iconPosition="right"
                        showMonthDropdown
                        showYearDropdown
                        closable
                        //enable={this.props.availableDates}
                        //marked={this.props.availableDates}
                        //markColor="teal"
                        //highlightDates={this.props.availableDates.map(date => moment(date, 'DD-MM-YYYY').toDate())}
                       // includeDates={this.props.availableDates.map((date) =>
                       //   moment(date, "DD-MM-YYYY").toDate()
                       // )}
                       highlightDates={enabledDates.map(date => moment(date, 'DD-MM-YYYY').toDate())}
                       filterDate={(date) => enabledDates.some((enabledDate) => enabledDate.toDateString() === date.toDateString())}
                       dayClassName={(date) => {
                         const isEnabled = enabledDates.some(
                           (enabledDate) => enabledDate.toDateString() === date.toDateString()
                         );
                         return isEnabled ? 'highlighted-day' : ''; // Add custom class to enabled dates
                       }}
                     scrollableYearDropdown
                        highlightDatesStyles="teal"
                        // startMode="date"
                        pickerWidth="300px"
                        popupPosition="top right"
                        minDate={new Date(Math.min(...enabledDates.map((d) => d.getTime())))} // Set the minimum date
                        maxDate={new Date(Math.max(...enabledDates.map((d) => d.getTime())))} // Set the maximum date
                    
                        clearIcon={<Icon name="remove" color="red" />}
                      />
                    </div>
                  </Accordion.Content>
                </Accordion>
              </div>
            </div>
          ) : null}
        </div>
      );
    }
  }
}